export enum TrackedEvent {
  NoteView = "note_view",
  NotesView = "notes_view",
  ImportedNotesView = "imported_notes_view",
  ImportViaCreateNote = "import_via_create_note",
  ImportViaUserProfileMenu = "import_via_user_profile_menu",
  NoteCreate = "note_create",
  NoteAddToCollection = "note_add_to_collection",
  AutoOrganizeNote = "auto_organize_note",
  NoteShare = "note_share",
  TemplateCreate = "template_create",
  TemplateUsed = "template_used",
  TemplateView = "template_view",
  TemplatesView = "templates_view",
  CollectionView = "collection_view",
  CollectionsView = "collections_view",
  ImportedCollectionsView = "imported_collections_view",
  CollectionCreate = "collection_create",
  CollectionShare = "collection_share",
  TemplateShare = "template_share",
  ChatView = "chat_view",
  ChatCreate = "chat_create",
  ChatCreateFromConversationTooLong = "chat_create_from_conversation_too_long",
  ChatResume = "chat_resume",
  ChatSelect = "chat_select",
  ChatMessageSend = "chat_message_send",
  ChatMessageSendFromSuggestion = "chat_message_send_from_suggestion",
  ChatMessageUpvote = "chat_message_upvote",
  ChatMessageDownvote = "chat_message_downvote",
  ChatInputLookAtClick = "chat_input_look_at_click",
  ChatInputAgentModeToggle = "chat_input_agent_mode_toggle",
  ChatInputContextAdd = "chat_input_context_add",
  ChatInputContextRemove = "chat_input_context_remove",
  SearchView = "search_view",
  SearchResultsOpenNote = "search_results_open_note",
  SearchResultsOpenCollection = "search_results_open_collection",
  QuickSearchView = "quick_search_view",
  QuickSearchOpenCollection = "quick_search_open_collection",
  QuickSearchOpenNote = "quick_search_open_note",
  ImportFrom1Dot0StartImport = "import_from_1_dot_0_start_import",
  ExportCreate = "export_create",
  PerformanceHeartbeat = "performance_heartbeat",
  SyncErrorShown = "sync_error_shown",
  AppCalloutBannerActionClicked = "app_callout_banner_action_clicked",
  AppCalloutBannerDismissed = "app_callout_banner_dismissed",
  PerformanceBootstrap = "performance_bootstrap",
  AppStoreInitErrorShown = "app_store_init_error_shown",
  ImportFilesDropped = "import_files_dropped",
  ImportFilesBatchStarted = "import_files_batch_started",
  ImportFilesBatchFailed = "import_files_batch_failed",

  // Email Capture Events
  EmailConnect = "email_connect",
  EmailDisconnect = "email_disconnect",
  EmailFormattingModeSelect = "email_formatting_mode_select",
  EmailFormattingSmartModeCustomize = "email_formatting_smart_mode_customize",
  EmailOrganizingModeChecked = "email_organizing_mode_checked",
  EmailOrganizingModeUnchecked = "email_organizing_mode_unchecked",
  EmailOrganizingSpecificCollectionsSaved = "email_organizing_specific_collections_saved",
  EmailOrganizingSmartModeCustomize = "email_organizing_smart_mode_customize",

  // Text Message Events
  TextFormattingModeSelect = "text_formatting_mode_select",
  TextFormattingSmartModeCustomize = "text_formatting_smart_mode_customize",
  TextOrganizingModeChecked = "text_organizing_mode_checked",
  TextOrganizingModeUnchecked = "text_organizing_mode_unchecked",
  TextOrganizingSpecificCollectionsSaved = "text_organizing_specific_collections_saved",
  TextOrganizingSmartModeCustomize = "text_organizing_smart_mode_customize",

  // API Request Events
  ApiKeyCreate = "api_key_create",
  ApiKeyName = "api_key_name",
  ApiKeyDelete = "api_key_delete",
  ApiDevDocsLinkClick = "api_dev_docs_link_click",

  // Zapier Events
  ZapierIntegrationLinkClick = "zapier_integration_link_click",
  ZapierDisconnect = "zapier_disconnect",

  // Voice Session Events
  VoiceSessionStart = "voice_session_start",
  VoiceSessionPause = "voice_session_pause",
  VoiceSessionResume = "voice_session_resume",
  VoiceSessionDone = "voice_session_done",
  VoiceSessionSuggestedEditsView = "voice_session_suggested_edits_view",
  VoiceSessionSuggestedEditsRefine = "voice_session_suggested_edits_refine",
  VoiceSessionSuggestedEditsAccept = "voice_session_suggested_edits_accept",
  VoiceSessionSuggestedEditsReject = "voice_session_suggested_edits_reject",
  VoiceRecordingView = "voice_recording_view",
  VoiceRecordingAudioPlay = "voice_recording_audio_play",
  VoiceRecordingTranscriptScroll = "voice_recording_transcript_scroll",
  DesktopSystemAudioPermissionsModalView = "desktop_system_audio_permissions_modal_view",
  DesktopSystemAudioPermissionInteract = "desktop_system_audio_permission_interact",
  DesktopSystemAudioPermissionOpenPreferences = "desktop_system_audio_permission_open_preferences",
  DesktopSystemAudioPermissionsRestartClick = "desktop_system_audio_permissions_restart_click",

  // Received from Electron
  MeetingDetectionNotificationView = "meeting_detection_notification_view",
  MeetingDetectionNotificationHover = "meeting_detection_notification_hover",
  MeetingDetectionNotificationDismiss = "meeting_detection_notification_dismiss",
  MeetingDetectionNotificationVoiceSessionStart = "meeting_detection_notification_voice_session_start",

  // Note Cleanup Events
  NoteCleanupStart = "note_cleanup_start",
  NoteCleanupRefine = "note_cleanup_refine",
  NoteCleanupAccept = "note_cleanup_accept",
  NoteCleanupReject = "note_cleanup_reject",

  // Welcome & Onboarding
  WelcomeOverlayView = "welcome_overlay_view",
  NativeUpsellView = "native_upsell_view",
  NativeUpsellSkip = "native_upsell_skip",
  NativeUpsellDownload = "native_upsell_download",
  IcpRfiStepComplete = "icp_rfi_step_complete",
  ReferrerStepComplete = "referrer_step_complete",
  OnboardingVoiceModeView = "onboarding_voice_mode_view",
  OnboardingVoiceModeOptionSelect = "onboarding_voice_mode_option_select",
  OnboardingVoiceModeSkip = "onboarding_voice_mode_skip",
  OnboardingDownloadClick = "onboarding_download_click",

  ImportCtaView = "import_cta_view",
  ImportWizardView = "import_wizard_view",
  ImportWizardAppSelect = "import_wizard_app_select",
  ImportWizardSkip = "import_wizard_skip",
  ImportWizardStepChange = "import_wizard_step_change",
  ImportWizardComplete = "import_wizard_complete",

  // OneClick Import Events
  OneClickImportListView = "one_click_import_list_view",
  OneClickImportItemSelect = "one_click_import_item_select",
  OneClickImportItemDeselect = "one_click_import_item_deselect",
  OneClickImportSelectAll = "one_click_import_select_all",
  OneClickImportDeselectAll = "one_click_import_deselect_all",
  OneClickImportCancel = "one_click_import_cancel",
  OneClickImportSubmit = "one_click_import_submit",

  // Multi-Tab Events
  PaneSplit = "pane_split",
  TabOpen = "tab_open",
  TabView = "tab_view",

  //Chrome Extension
  ChromeExtensionOnboardingInstallerView = "chrome_extension_onboarding_installer_view",
  ChromeExtensionOnboardingInstallerClick = "chrome_extension_onboarding_installer_click",
  ChromeExtensionHomeCarouselInstallerClick = "chrome_extension_home_carousel_installer_click",
  ChromeExtensionCustomInstructionsSave = "chrome_extension_custom_instructions_save",

  // Session Chat
  ChatSessionMessageSend = "chat_session_message_send",
  ChatSessionMessageUpvote = "chat_session_message_upvote",
  ChatSessionMessageDownvote = "chat_session_message_downvote",
  ChatPanelView = "chat_panel_view",
  SidePanelView = "side_panel_view",

  // Monetization / Paywall
  PaywallView = "paywall_view",
  PaywallCancelClick = "paywall_cancel_click",
  PaywallUpgradeClick = "paywall_upgrade_click",
  PaywallUpgradeReturn = "paywall_upgrade_return",
  PaywallCancelReturn = "paywall_cancel_return",
  FeatureGateBannerView = "feature_gate_banner_view",
  FeatureGateBannerUpgradeClick = "feature_gate_banner_upgrade_click",

  // Heads Up
  HeadsUpItemHover = "heads_up_item_hover",
  HeadsUpItemClick = "heads_up_item_click",
  HeadsUpRefreshClick = "heads_up_refresh_click",
  HeadsUpRegenerateClick = "heads_up_regenerate_click",
  HeadsUpFindMoreClick = "heads_up_find_more_click",

  // App and UI Readiness
  AppStoreInitialize = "app_store_initialize",
  UiReady = "ui_ready",
  LegacyBrowserBlocked = "legacy_browser_blocked",

  // Standrdized Experiment
  ExperimentStarted = "experiment_started",

  // Getting Started Guide
  GettingStartedStepCompleted = "getting_started_step_completed",
  GettingStartedDismissed = "getting_started_dismissed",
  GettingStartedToggled = "getting_started_toggled",
  GettingStartedAllComplete = "getting_started_all_complete",
  GettingStartedOnboardingTooltipDismissed = "getting_started_onboarding_tooltip_dismissed",

  // Editor
  ClipboardPaste = "clipboard_paste",

  // System Permissions
  MeetingNotificationsSetupView = "meeting_notifications_setup_view",
  MeetingNotificationsSetupSubmit = "meeting_notifications_setup_submit",
  VoiceSetupView = "voice_setup_view",
  VoiceSetupSubmit = "voice_setup_submit",
}

export enum TrackedEventContext {
  FloatingBar = "floating_bar",
  Notes = "notes",
  InsertMenu = "insert_menu",
}

// Monetization contexts for paywall-related events
export enum PaywallContext {
  NoteCreate = "note_create",
  NoteMentionCreate = "note_mention_create",
  ChatMessageSend = "chat_message_send",
  NoteList = "note_list",
  CollectionList = "collection_list",
  DarkModeToggle = "dark_mode_toggle",
}

// Tab Navigation Event Parameters
export interface PaneSplitEventParams {
  origin_pane_index: number | string;
}

export interface TabOpenEventParams {
  view_id: string;
  pane_index: number;
}

export interface TabViewEventParams {
  view_id: string;
  pane_index: number;
}

export interface ExperimentStartedEventParams {
  experiment: string;
  variant: string;
  context?: Record<string, unknown>;
}

export interface SidePanelViewEventParams {
  variant: "control" | "treatment";
}

// Getting Started Event Parameters
export interface GettingStartedStepCompletedEventParams {
  step_id: string;
  step_title: string;
  completed_count: number;
  total_count: number;
}

export interface GettingStartedToggledEventParams {
  is_expanded: boolean;
}

// OneClick Import Event Parameters
export interface OneClickImportListViewEventParams {
  total_notes_count: number;
  selectable_notes_count: number;
  locked_notes_count: number;
}

export interface OneClickImportItemSelectEventParams {
  note_title: string;
  note_subtitle: string | undefined;
  selected_count: number;
  total_count: number;
}

export interface OneClickImportItemDeselectEventParams {
  note_title: string;
  note_subtitle: string | undefined;
  selected_count: number;
  total_count: number;
}

export interface OneClickImportSelectAllEventParams {
  selected_count: number;
  total_count: number;
}

export interface OneClickImportDeselectAllEventParams {
  previously_selected_count: number;
  total_count: number;
}

export interface OneClickImportCancelEventParams {
  selected_count: number;
  total_count: number;
}

export interface OneClickImportSubmitEventParams {
  selected_count: number;
  total_count: number;
  use_folders_as_collections: boolean;
}

/**
 * Type-safe mapping of TrackedEvent to their required properties.
 * Events not listed here will fall back to Record<string, unknown>.
 */
export type TrackedEventProperties = {
  [TrackedEvent.ExperimentStarted]: ExperimentStartedEventParams;
  [TrackedEvent.PaneSplit]: PaneSplitEventParams;
  [TrackedEvent.TabOpen]: TabOpenEventParams;
  [TrackedEvent.TabView]: TabViewEventParams;
  [TrackedEvent.SidePanelView]: SidePanelViewEventParams;
  [TrackedEvent.GettingStartedStepCompleted]: GettingStartedStepCompletedEventParams;
  [TrackedEvent.GettingStartedToggled]: GettingStartedToggledEventParams;
  [TrackedEvent.OneClickImportListView]: OneClickImportListViewEventParams;
  [TrackedEvent.OneClickImportItemSelect]: OneClickImportItemSelectEventParams;
  [TrackedEvent.OneClickImportItemDeselect]: OneClickImportItemDeselectEventParams;
  [TrackedEvent.OneClickImportSelectAll]: OneClickImportSelectAllEventParams;
  [TrackedEvent.OneClickImportDeselectAll]: OneClickImportDeselectAllEventParams;
  [TrackedEvent.OneClickImportCancel]: OneClickImportCancelEventParams;
  [TrackedEvent.OneClickImportSubmit]: OneClickImportSubmitEventParams;
  // Add more specific event types here as needed
};

/**
 * Helper type to get properties for a specific TrackedEvent.
 * Falls back to Record<string, unknown> for events without specific properties.
 */
export type PropertiesForEvent<T extends TrackedEvent> = T extends keyof TrackedEventProperties
  ? TrackedEventProperties[T]
  : Record<string, unknown>;
